import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function HelpArticles() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const articles = data?.help?.articles || [];

  return (
    <MainPanel title={t('help.articlesTitle')} subtitle={t('help.articlesSubtitle')}>
      {articles.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('help.articlesEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('help.articlesEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {articles.map((a) => (
            <div
              key={a.id}
              style={{
                background: '#1f2229',
                borderRadius: 12,
                padding: '18px 20px',
                color: '#f3f4f6',
                border: '1px solid rgba(255,255,255,0.06)',
              }}
            >
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>{a.title}</h3>
              <p style={{ margin: '8px 0 0', fontSize: 12, color: '#6b7280' }}>
                {a.category || t('common.general')} · {a.locale || '—'}
              </p>
              <p style={{ margin: '12px 0 0', fontSize: 14, color: '#9ca3af', whiteSpace: 'pre-wrap' }}>{a.body}</p>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
